import { AfterViewInit, Component, ElementRef, Inject, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, Validators } from '@angular/forms';
import { AssessmentService } from 'src/app/services/assessment.service';
import { Title } from '@angular/platform-browser';
import { UserService } from 'src/app/services/user.service';
import { ReportService } from 'src/app/services/report.service';
import { ConfirmationToastComponent } from 'src/app/components/confirmation-toast/confirmation-toast.component';
import { MatTableDataSource } from '@angular/material/table';
import { UserMemberService } from 'src/app/services/user-member.service';
import { faUsers, faFire, faWarning } from '@fortawesome/free-solid-svg-icons';
import { Observable, map, of, startWith } from 'rxjs';
import { DialogService } from 'src/app/services/dialog.service';
import { MatSort } from '@angular/material/sort';

export enum ModalState {
  NEW_OR_EXISTING = "NEW_OR_EXISTING",
  SEARCH_SKILL = "SEARCH_SKILL",
  SELECT_SKILL = "SELECT_SKILL",
  ADD_NEW_USER = "ADD_NEW_USER",
  NEW_USER_SELECT_SKILL = "NEW_USER_SELECT_SKILL",
  EDIT_SKILL = "EDIT_SKILL"
}

@Component({
    selector: 'app-add-team-member',
    templateUrl: './add-team-member.component.html',
    styleUrl: './add-team-member.component.scss',
    standalone: false
})
export class AddTeamMemberComponent implements OnInit, AfterViewInit {

  currentUser: any;
  faUsers = faUsers;
  faFire = faFire;
  faWarning = faWarning;
  private readonly fireRecord: any = this.data.fireRecord;

  selectedUser: any;

  team_needs: any[];
  leadList: any[] = [];
  skillList: any[] = [];
  expList: any[] = [];
  regions: any[];
  roles: any[];
  is_WO: boolean = false;


  formValid = false;
  users = new MatTableDataSource<any>();
  usersSource: any[] = [];
  displayedColumns: string[] = ["name", "skills", "assignment_status"];
  state: ModalState = ModalState.NEW_OR_EXISTING;

  // User Vars
  forest_names: any;
  forest_names_duty: any;
  filtered_forest_names: Observable<string[]>;
  filtered_forest_names_duty: Observable<string[]>;
  @ViewChild('forest') input?: ElementRef<HTMLInputElement>;
  @ViewChildren(MatSort) sort!: QueryList<MatSort>;
  agency_list: any;
  selectedForestFlag = false;
  selectedForestFlag_duty = false;
  userExists = false;
  lastCheckedEmail: any = "";

  fireForm = this.formBuilder.group({
    support_type: [""],
    editor: [""],
    role: [-1],
    skills: [""],
    other_skill: [""],
    new_or_existing: [""],
    search_skills: [""],
    skill_level: [""],
    availability: [""],
    user_name: [""],
    region: [""],
    radio: [""],
    NIS_cert: [false],
  });

  userForm = this.formBuilder.group({
    first_name: [""],
    last_name: [""],
    region: [""],
    forest_name: [""],
    agency_id: [-1, [Validators.min(0), Validators.required]],
    location_id: [-1],
    duty_region: [""],
    duty_forest_name: [""],
    duty_location_id: [-1],
    email: [""],
    phone_num: [""],
  });



  constructor(
    public dialogRef: MatDialogRef<AddTeamMemberComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly formBuilder: FormBuilder,
    private readonly toast: ConfirmationToastComponent,
    private readonly assessmentService: AssessmentService,
    private readonly titleService: Title,
    public readonly userService: UserService,
    private readonly reportService: ReportService,
    public readonly userMemberService: UserMemberService,
    public readonly dialogService: DialogService,
  ) {
    this.titleService.setTitle("BAER - Add Team Member")
    dialogRef.disableClose = true;

    this.regions = this.assessmentService.getRegionList().slice();
    this.regions.unshift("All Regions")
    this.roles = this.userMemberService.getRoleList();

    this.fireForm.valueChanges.subscribe(value => {
      this.checkValidForm();
    })

    this.team_needs = this.assessmentService.getBAERTeamNeeds();
    this.userService.getSkillList().subscribe(skillsList => {
      skillsList.forEach((skill: any) => {
        this.skillList.push({ name: skill.text, checked: false, skill_id: skill.value });
      })
      this.skillList = this.skillList.filter((skill: any) => skill.skill_id <= 19 && skill.skill_id != 14 && skill.skill_id != 17)
      this.skillList.push({ name: "Other", checked: false, skill_id: 14 })
    });

    this.expList = this.userService.getExpList();

    // User form section

    this.forest_names = this.assessmentService.getForestNameList();
    this.forest_names_duty = this.assessmentService.getForestNameList();
    this.agency_list = this.userService.getAgencyList();

    this.filtered_forest_names = this.userForm.controls["forest_name"].valueChanges.pipe(
      startWith(""),
      map((value) => this._filter((value as string) || ""))
    )

    this.filtered_forest_names_duty = this.userForm.controls["duty_forest_name"].valueChanges.pipe(
      startWith(""),
      map((value) => this._filter((value as string) || ""))
    )

    // End user form section

  }

  continue() {
    if (this.state == ModalState.NEW_OR_EXISTING) {
      if (this.fireForm.value.new_or_existing == "Existing") {
        this.state = ModalState.SEARCH_SKILL
      } else if (this.fireForm.value.new_or_existing == "New") {
        this.state = ModalState.ADD_NEW_USER
      }
    } else if (this.state == ModalState.SEARCH_SKILL) {
      this.state = ModalState.SELECT_SKILL
    } else if (this.state == ModalState.ADD_NEW_USER) {
      this.state = ModalState.NEW_USER_SELECT_SKILL
    }
  }

  back() {
    if (this.state == ModalState.SEARCH_SKILL) {
      this.state = ModalState.NEW_OR_EXISTING
    } else if (this.state == ModalState.SELECT_SKILL) {
      this.state = ModalState.SEARCH_SKILL
      this.fireForm.patchValue({
        radio: this.selectedUser
      })
    } else if (this.state == ModalState.ADD_NEW_USER) {
      this.state = ModalState.NEW_OR_EXISTING
    } else if (this.state == ModalState.NEW_USER_SELECT_SKILL) {
      this.state = ModalState.ADD_NEW_USER
    }
  }

  checkValidForm() {
    this.formValid = true
    let invalidForm = true
    for (let item of this.skillList) {
      if (item.checked) {
        invalidForm = false
        break
      }
    }
    if (this.skillList[this.skillList.length - 1]?.checked) {
      if (this.fireForm.value.other_skill == "") {
        invalidForm = true;
      }
    }
    if (invalidForm) {
      this.formValid = false
    }
  }

  ngOnInit(): void {
    this.dialogService.openSpinner();
    this.is_WO = this.data.user.woOffice;

    this.loadUsers();

    if (this.data.member) { //edit member
      this.state = ModalState.EDIT_SKILL
      this.titleService.setTitle("BAER - Edit Team Member");
      for (let skill of this.data.member.skills) {
        this.skillList.find((item: any) => item.skill_id == skill.skill_id).checked = true
      }
      this.setTooltip([this.data.member.user])
      this.selectedUser = this.data.member.user;
      this.fireForm.patchValue({
        editor: this.data.member.editor,
        role: this.data.member.role_id,
        skills: this.data.member.skills,
        other_skill: this.data.member.skills.find((skill: any) => skill.skill_id == 14)?.other_skill
      })
    }
  }
  ngAfterViewInit() {
    this.sort.changes.subscribe((sort: QueryList<MatSort>) => {
      this.users.sort = sort.last;
    })
  }

  roleChange(value: any) {
    let patch: any = false;
    if (this.state == ModalState.SELECT_SKILL) {
      if (value == 1 || value == 0) {
        patch = true;
      }
      this.fireForm.patchValue({
        editor: patch
      })
    }
  }


  sumbitRequest(): void {
    this.dialogService.openSpinner()
    if (this.state == ModalState.NEW_USER_SELECT_SKILL) {
      if (this.userForm.value.phone_num?.length == 0) this.userForm.value.phone_num = undefined;
      if (this.userForm.value.location_id == 2) {
        this.userForm.patchValue({
          region: "WO"
        })
      } else if (this.userForm.value.location_id == -1) {
        this.userForm.patchValue({
          location_id: undefined
        })
      }
      if (this.userForm.value.duty_location_id == 2) {
        this.userForm.patchValue({
          duty_region: "WO"
        })
      } else if (this.userForm.value.duty_location_id == -1) {
        this.userForm.patchValue({
          duty_location_id: undefined
        })
      }
      this.userService.createNewUser({
        first_name: this.userForm.value.first_name!,
        last_name: this.userForm.value.last_name!,
        region: this.userForm.getRawValue().region ?? undefined,
        forest_name: this.userForm.getRawValue().forest_name ?? undefined,
        agency_id: this.userForm.value.agency_id,
        location_id: this.userForm.getRawValue().location_id,
        duty_region: this.userForm.getRawValue().duty_region ?? undefined,
        duty_forest_name: this.userForm.getRawValue().duty_forest_name ?? '',
        duty_location_id: this.userForm.getRawValue().duty_location_id,
        phone_num: this.userForm.value.phone_num,
        email: this.userForm.getRawValue().email!,
        user_baer_roles: [{ baer_role_id: 2 }],
        procedure: 'NEW_TO_ALL'
      }).subscribe({
        next: (response) => {
          this.userService.getUsersByEmail(this.userForm.getRawValue().email!).subscribe({
            next: (response) => {
              this.selectedUser = response.users[0] // Should only return the one new user
              this.addUserToReport()
            },
            error: (response) => {
              this.dialogService.closeSpinner();
              this.toast.openErrorSnackBar("There was an error fetching the new user info.", "Please try adding the user again.");
              this.dialogRef.close();
            },
          })
        },
        error: (response) => {
          this.dialogService.closeSpinner();
          this.toast.openErrorSnackBar("There was an error adding the new user.", "Please try adding the user again.");
          this.dialogRef.close();
        },
      })
    } else if (this.state == ModalState.EDIT_SKILL) {
      this.editUser();
    } else {
      this.addUserToReport();
    }
  }

  addUserToReport(): void {
    let otherSkill = this.skillList.find((skill: any) => skill.name == "Other")

    if (otherSkill?.checked) {
      otherSkill.other_skill = this.fireForm.value.other_skill
    }

    this.userMemberService.addUserToReport(this.data.report.report_id, {
      user_id: this.selectedUser.user_id,
      role_id: this.fireForm.value.role as number,
      editor: this.fireForm.value.editor as unknown as boolean,
      memberSkills: this.skillList.filter((skill: any) => skill.checked)
    }).subscribe({
      next: (response) => {
        this.checkAssessmentLead();
        let completedSupports = this.checkIfAnySupportComplete()
        if (completedSupports.length > 0) {
          this.supportCompleted(completedSupports)
        } else {
          this.dialogService.closeSpinner();
          this.toast.openSuccessSnackBar(`Team member has been added to the report.`);
          this.dialogRef.close(true);
        }
      },
      error: (response) => {
        this.dialogService.closeSpinner();
        this.toast.openErrorSnackBar(`There was an error adding the team member.`, "Please try editing the assessment again.");
        this.dialogRef.close();
      },
    })
  }

  checkAssessmentLead() {
    if (this.data.assessment.team_lead_id == null && this.fireForm.value.role == 0) {
      this.assessmentService.editAssessment({
        assessment_id: this.data.assessment.assessment_id,
        team_lead_id: this.selectedUser.user_id as number | undefined,
      }).subscribe({
        error: (response) => {
          this.toast.openErrorSnackBar(`There was an error updating ${this.fireRecord.baer_name}.`, "Please try editing the assessment again.");
        },
      })
    }
  }

  editUser(): void {
    let otherSkill = this.skillList.find((skill: any) => skill.name == "Other")

    if (otherSkill.checked) {
      otherSkill.other_skill = this.fireForm.value.other_skill
    }

    this.userMemberService.updateMember(this.data.member.user_id, this.data.report.report_id, {
      role_id: this.fireForm.value.role as number,
      editor: this.fireForm.value.editor as unknown as boolean,
      memberSkills: this.skillList.filter((skill: any) => skill.checked)
    }).subscribe({
      next: (response) => {
        this.dialogService.closeSpinner();
        this.toast.openSuccessSnackBar(`Team member information has been updated.`);
        this.dialogRef.close(true);
      },
      error: (response) => {
        this.dialogService.closeSpinner();
        this.toast.openErrorSnackBar(`There was an error updating the team member.`, "Please try editing the assessment again.");
        this.dialogRef.close();
      },
    })
  }

  checkIfAnySupportComplete(): any[] {
    let completed: any[] = [];
    this.data.report.supports.forEach((support: any) => {
      if (support.support_completed) {
        return
      }
      if (this.checkIfSupportComplete(support)) {
        completed.push(support)
      }
    })
    return completed;
  }

  checkIfSupportComplete(support: any): boolean {
    if (support.support_type == "Team Member(s)" || support.support_type == "Shortage Team Members") {
      let newSkills: string[] = this.skillList.filter((skill: any) => skill.checked).map((skill: any) => {
        if (skill.name == "Other") {
          return this.fireForm.value.other_skill
        }
        return skill.name
      })
      let neededSkills = support.support_skills.split(", ")
      let allUserSkills = this.data.report.users.flatMap((user: any) => {
        return user.skills.map((skill: any) => {
          if (skill.skill.text == "Other") {
            return skill.other_skill
          }
          return skill.skill.text
        })
      }).concat(newSkills)
      let remainingSkills = neededSkills.filter((skill: string) => {
        return !allUserSkills.includes(skill)
      })
      return remainingSkills.length == 0 // All skills have been filled

    } else if (support.support_type == "Team Lead") {
      return this.fireForm.value.role as number == 0 // Newest member is a Team Lead
    }
    return false;
  }

  updateSkill(skill: any) {
    skill.checked = !skill.checked
    this.checkValidForm();
  }

  loadUsers() {
    this.userService.getUserList("", ["assessments", "skills", "baer_roles.baer_role", "reportMembers.report.assessment"]).subscribe(data => {
      let users;
      if (this.data.isWO)
        users = data.users
      else {
        users = data.users.filter((user: any) => this.data.assessment.region.includes(user.region) || this.data.assessment.region.includes(user.duty_region))
      }
      this.sortFlattenAssessments(users);
      this.usersSource = users
      this.setTooltip(users);
      this.users.data = users;
      this.users.sortingDataAccessor = (item, property) => {
        switch (property) {
          case 'name':
            return item.last_name + item.first_name;
          case 'assignment_status': {
            let statSort = 0;
            if (!(item.available_personal ?? true)) statSort = 2;
            if (item.filteredAssessment) statSort = 1;
            return statSort;
          }
          default:
            return item.property;
        }
      }
      this.dialogService.closeSpinner();
    });
  }

  setTooltip(users: any) {
    users.forEach((user: any) => {
      let tooltip = '';
      let tooltip2 = '';
      for (let i = 1; user.skills.length - 1 >= i; i++) {
        tooltip += user.skills[i].skill.text + '\n'
      }
      for (let i = 1; user.baer_roles?.length - 1 >= i; i++) {
        tooltip2 += user.baer_roles[i].baer_role.text + '\n'
      }
      user.tooltip = tooltip;
      user.tooltip2 = tooltip2
    });
  }

  radioChange(event: any) {
    this.selectedUser = event.value;
  }

  filterUsers() {
    let skillList = this.fireForm.value.search_skills as any as string[]
    let skillLevels = this.fireForm.value.skill_level as any as number[]
    if (skillList && skillList.length > 0) {
      this.users.data = this.usersSource.filter((user: any) => {
        let good = false
        let userSkillList = user.skills.filter((item: any) => {
          if (skillLevels && skillLevels.length > 0) {
            if (!skillLevels.includes(item.experience_id)) return false
          }
          return true
        }).map((object: any) => object.skill.text)
        skillList.forEach((skill: string) => {
          if (userSkillList.includes(skill)) {
            good = true;
          }
        })
        return good
      });
      //move selected skill to front
      this.users.data = this.users.data.filter((e: any) => {
        e.skillIndex = e.skills.map((e: any) => e.skill.text).indexOf(skillList[0]);
        if (e.skillIndex != -1) {
          let tempSkill = e.skills[e.skillIndex];
          e.skills[e.skillIndex] = e.skills[0];
          e.skills[0] = tempSkill;
        }
        return true;
      })
    } else {
      this.users.data = this.usersSource
      // If no skill is specified, filter users with any skill at that experience level
      if (skillLevels && skillLevels.length > 0) {
        this.users.data = this.users.data.filter((user: any) => {
          return user.skills.find((item: any) => {
            return skillLevels.includes(item.experience_id)
          })
        })
      }
    }
    this.filterUsersDataFurther();
  }

  filterUsersDataFurther() {
    if (this.fireForm.value.user_name) {
      let name = this.fireForm.value.user_name.toLocaleLowerCase()
      this.users.data = this.users.data.filter((user: any) => {
        return user.first_name.toLocaleLowerCase().includes(name) || user.last_name.toLocaleLowerCase().includes(name)
      })
    }
    if (this.fireForm.value.NIS_cert && this.fireForm.value.search_skills?.includes('GIS')) {
      this.users.data = this.users.data.filter((user: any) => {
        return user.NIS_BAER
      })
    }
    if (this.fireForm.value.availability && this.fireForm.value.availability.length > 0) {
      let nation_available = this.fireForm.value.availability.includes("nation")
      let region_available = this.fireForm.value.availability.includes("region")
      this.users.data = this.users.data.filter((user: any) => {
        return (nation_available && user.available_nation) || (region_available && user.available_region)
      })
    }
    if (!this.is_WO || (this.fireForm.value.region && this.fireForm.value.region != "All Regions")) {
      let region = this.fireForm.value.region
      if (!this.is_WO) { // If not WO, only show users in fire's region
        region = this.data.assessment.region
      }
      this.users.data = this.users.data.filter((user: any) => {
        return user.region == region
      })
    }
    if (this.selectedUser && !this.users.data.includes(this.selectedUser)) {
      this.selectedUser = null
    }
  }

  supportCompleted(supports: any[]) {
    supports.forEach((support: any) => {
      support.support_completed = true
    })
    this.reportService.updateReport({
      report_id: this.data.report.report_id,
      supports: supports
    }).subscribe({
      next: (response) => {
        this.dialogService.closeSpinner();
        this.toast.openSuccessSnackBar(`Team member has been added to the report.`);
        this.dialogRef.close({ supportsCompleted: supports });
      },
      error: (response) => {
        this.dialogService.closeSpinner();
        this.toast.openErrorSnackBar(`The team member was added, but there was an error updating the report.`, "Please try again if needed.");
        this.dialogRef.close();
      },
    })
  }


  // User Form Portion

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase()
    return this.forest_names.filter((option: string) =>
      option.toLowerCase().includes(filterValue)
    )
  }

  private _filter_duty(value: string): string[] {
    const filterValue = value.toLowerCase()
    return this.forest_names_duty.filter((option: string) =>
      option.toLowerCase().includes(filterValue)
    )
  }

  filter(): void {
    const filterValue = this.input?.nativeElement.value.toLowerCase() ?? '';
    this.filtered_forest_names = of(this._filter(filterValue));
  }

  filter_duty(): void {
    const filterValue = this.input?.nativeElement.value.toLowerCase() ?? '';
    this.filtered_forest_names_duty = of(this._filter_duty(filterValue));
  }

  regionChanged(): void {
    this.userForm.patchValue({ forest_name: undefined })
    this.forest_names = this.assessmentService.getForestNameList(this.userForm.value.region ?? undefined);
    this.filtered_forest_names = this.userForm.controls["forest_name"].valueChanges.pipe(
      startWith(""),
      map((value) => this._filter((value as string) || ""))
    )
  }

  regionChanged_duty(): void {
    this.userForm.patchValue({ duty_forest_name: undefined })
    this.forest_names_duty = this.assessmentService.getForestNameList(this.userForm.value.duty_region ?? undefined);
    this.filtered_forest_names_duty = this.userForm.controls["duty_forest_name"].valueChanges.pipe(
      startWith(""),
      map((value) => this._filter_duty((value as string) || ""))
    )
  }

  updateValidators(value: any, type: any) {
    let location_id = this.userForm.controls.location_id.value;
    let duty_location_id = this.userForm.controls.duty_location_id.value;
    let agency_id = this.userForm.value.agency_id;
    if (type == 'location_id') {
      location_id = value;
    }
    if (type == 'duty_location_id') {
      duty_location_id = value;
    }
    if (type == 'agency_id') {
      agency_id = value;
    }
    this.updateValidatorsCheck(location_id, duty_location_id, agency_id);
  }

  updateValidatorsCheck(location_id: any, duty_location_id: any, agency_id: any): void {
    if (location_id != 0) {
      this.userForm.controls.forest_name.clearValidators();
      this.userForm.controls.forest_name.setValue('');

      if (location_id != 1) {
        this.userForm.controls.region.clearValidators();
        this.userForm.controls.region.setValue(null);
      }
    }
    if (duty_location_id != 0) {
      this.userForm.controls.duty_forest_name.clearValidators();
      this.userForm.controls.duty_forest_name.setValue('');

      if (duty_location_id != 1) {
        this.userForm.controls.duty_region.clearValidators();
        this.userForm.controls.duty_region.setValue(null);
      }
    }
    if (agency_id != 0 && location_id == 2) {
      this.userForm.controls.location_id.setValue(null);
    }

    let type: string | null = null;
  }

  clearForest() {
    if (!this.selectedForestFlag) {
      this.userForm.patchValue({
        forest_name: ""
      })
    }
    this.selectedForestFlag = false
  }

  clearForest_duty() {
    if (!this.selectedForestFlag_duty) {
      this.userForm.patchValue({
        duty_forest_name: ""
      })
    }
    this.selectedForestFlag_duty = false
  }

  forestNameSelected(event: any): void {
    this.selectedForestFlag = true
  }

  forestNameSelected_duty(event: any): void {
    this.selectedForestFlag_duty = true
  }

  checkIfUserExists(): void {
    if (this.lastCheckedEmail == this.userForm.getRawValue().email) return // Prevent double event firing
    this.lastCheckedEmail = this.userForm.getRawValue().email
    if (this.userForm.getRawValue().email == "") {
      this.userExists = false;
      return
    }
    this.dialogService.openSpinner();
    this.userService.getUsersByEmail(this.userForm.getRawValue().email!).subscribe({
      next: (response) => {
        this.dialogService.closeSpinner();
        if (response.totalResults > 0) {
          this.userExists = true;
          this.userForm.controls.email.setErrors({ invalidEmail: true });
        } else {
          this.userExists = false;
        }
      },
      error: (response) => {
        this.userExists = false;
        this.dialogService.closeSpinner();
      },
    })
  }

  sortFlattenAssessments(users: any) {
    const today = new Date();
    for (let user of users) {
      let assessments: any = [];
      let filteredMembers = user.reportMembers.filter((x: any) => !x.demobilize)
      let filteredReports: any[] = []
      filteredMembers.forEach((x: any) => filteredReports.push(x.report));
      assessments = [...assessments, ...user.assessments];
      for (let report of filteredReports) {
        assessments = [...assessments, ...[report.assessment]];
      }
      assessments = assessments.filter((x: any) => (new Date(x.close_out_date)) > today);
      assessments.sort((a: any, b: any) => a.close_out_date > b.close_out_date);
      user.filteredAssessment = assessments[0];

      if (user.filteredAssessment) {
        user.filteredAssessment.tentative_start_week_filtered = (new Date(user.filteredAssessment.tentative_start_week)).toLocaleDateString("en-US");
        user.filteredAssessment.close_out_date_filtered = (new Date(user.filteredAssessment.close_out_date)).toLocaleDateString("en-US")
      }
    }
  }
}
